var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyLinkCompletedIcon = function SvgCopyLinkCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.654 10c-.535 0-.969.448-.969 1v9c0 .552.434 1 .969 1h8.716c.535 0 .969-.448.969-1v-9c0-.552-.434-1-.969-1zm-2.906 1c0-1.657 1.3-3 2.906-3h8.716c1.605 0 2.906 1.343 2.906 3v9c0 1.657-1.301 3-2.906 3h-8.716c-1.605 0-2.906-1.343-2.906-3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.874 3a.95.95 0 0 0-.685.293A1.02 1.02 0 0 0 2.906 4v9c0 .265.102.52.283.707a.95.95 0 0 0 .685.293h.969c.534 0 .968.448.968 1s-.434 1-.968 1h-.969a2.86 2.86 0 0 1-2.054-.879A3.05 3.05 0 0 1 .969 13V4c0-.796.306-1.559.85-2.121A2.86 2.86 0 0 1 3.875 1h8.717c.77 0 1.51.316 2.054.879A3.05 3.05 0 0 1 15.496 4v1c0 .552-.434 1-.968 1-.535 0-.969-.448-.969-1V4c0-.265-.102-.52-.284-.707A.95.95 0 0 0 12.591 3z",
    clipRule: "evenodd"
  })));
};
export default SvgCopyLinkCompletedIcon;